import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { SectionPaper } from "@/components/AcquireBook/SectionPaper";
import { Label } from "@/components/Label";
import { Button, ButtonVariantOption } from "@/components/Button";
import { SizingWrapperStyle } from "@/components/Wrapper/SizingWrapper";
import { formatNumberWithComma } from "@/utils/formatNumber";
interface OwnerRelatedRegistriesSectionProps {
  disabled: boolean;
  isSearching: boolean;
  selectionCount: number;
  onSearchClick: () => void;
}

export const OwnerRelatedRegistriesSection: React.FC<
  OwnerRelatedRegistriesSectionProps
> = ({ disabled, isSearching, selectionCount, onSearchClick }) => {
  return (
    <Box sx={{ mx: 2, mt: 3 }}>
      <Label>同一の不動産オーナー名で名寄せ検索</Label>
      <SectionPaper>
        <Box sx={{ px: 2, py: 2 }}>
          <Stack spacing={1.5} sx={{ alignItems: "flex-start" }}>
            <Typography variant="body2" color="text.secondary">
              所有者名をもとに指定される他の不動産の登記情報を検索します
            </Typography>
            <Button
              label={"検索する"}
              onClick={onSearchClick}
              variant={ButtonVariantOption.Contained}
              disabled={disabled}
              hasLoading
              loading={isSearching}
              size={SizingWrapperStyle.SMALL}
            />
            <Typography variant="body2" color="text.secondary">
              選択件数: {formatNumberWithComma(selectionCount)}件
            </Typography>
          </Stack>
        </Box>
      </SectionPaper>
    </Box>
  );
};
